/**
 * Módulo de Banners - Index
 *
 * Ponto central de exportação para o módulo de banners
 */

// Componentes
export { default as BannerCarousel } from "./components/BannerCarousel.vue";

// Serviços
export { bannerService } from "./services/bannerService";

// Configurações
export {
  bannerConfig,
  BANNER_CONFIG,
  BANNER_VERSION,
} from "./config/bannerConfig";

// Exportação padrão com todos os recursos
export default {
  components: {
    BannerCarousel: () => import("./components/BannerCarousel.vue"),
  },
  services: {
    bannerService: () => import("./services/bannerService"),
  },
  config: {
    bannerConfig: () => import("./config/bannerConfig"),
  },
};
